// extracted by mini-css-extract-plugin
export default {"start_mess":"StartMessage_start_mess__Wv3VG","cont":"StartMessage_cont__RbRuQ","box":"StartMessage_box__XOOrI","img":"StartMessage_img__mA5+W"};